<template>
  <div id="pageRoot" class="blind">
    <p class="pageElement title" style="left: 160px; top: 40px; font-size: 60px;">
      ÁLBUM DE PALABRAS
    </p>

    <p class="pageElement big" style="left: 60px; top: 230px; font-size: 60px;">
    I
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      defaultText="Araña"
      disabled
      id="inputField01"
    />

    <p class="pageElement big" style="left: 60px; top: 330px; font-size: 60px;">
      J
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
    />

    <p class="pageElement big" style="left: 60px; top: 430px; font-size: 60px;">
      K
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
    />

    <p class="pageElement big" style="left: 60px; top: 530px; font-size: 60px;">
     L
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="4"
      id="inputField04"
    />

    <p class="pageElement big" style="left: 570px; top: 230px; font-size: 60px;">
      M
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="5"
      id="inputField05"
    />

    <p class="pageElement big" style="left: 570px; top: 330px; font-size: 60px;">
      N
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="6"
      id="inputField06"
    />

    <p class="pageElement big" style="left: 570px; top: 430px; font-size: 60px;">
     Ñ
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="7"
      id="inputField07"
    />

    <p class="pageElement big" style="left: 570px; top: 540px; font-size: 60px;">
      O
    </p>
    <saved-input-narrator-friendly
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="8"
      id="inputField08"
    />
  </div>
</template>
<style scoped>
#inputField01 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 307px;
}
#inputField02 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 407px;
}
#inputField03 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 507px;
}
#inputField04 {
  position: absolute;
  width: 310px;
  left: 120px;
  top: 607px;
}
#inputField05 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 305px;
}
#inputField06 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 407px;
}
#inputField07 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 507px;
}
#inputField08 {
  position: absolute;
  width: 310px;
  left: 620px;
  top: 615px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["alb/Video 3b.mp4"],
    }
  }
}
</script>